export enum FixesPermissions {
  ChoiceDeduplicator = 'choice-deduplicator',
  ChoiceDeleter = 'choice-deleter',
}
